import { render } from "./ConfirmBtn.vue?vue&type=template&id=6f3c2ce7&scoped=true"
import script from "./ConfirmBtn.vue?vue&type=script&lang=js"
export * from "./ConfirmBtn.vue?vue&type=script&lang=js"

import "./ConfirmBtn.vue?vue&type=style&index=0&id=6f3c2ce7&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3c2ce7"]])

export default __exports__